/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes/'
export default StyleSheet.create({
  container: {
    flex: 1
  },
  closeButton : {

    width: 40,
    height: 40,
    alignItems: `center`,
    justifyContent: `center`
  },
  boldText : {
    fontFamily: Fonts.style.font.bold
  },
  captionView: {
    flex: 1, flexDirection: `row`, flexWrap: "wrap" 
  },
 
  scrollview : {
  backgroundColor: 'white', marginTop: 40, bottom: 0, left: 0, right: 0
  }
})
